module.exports = __webpack_public_path__ + "aed48fbef19b3ec6af0ecd7f182b84d1.gif";